export const REGEX_E_SIGNATURE = /"errorCode":"([^"]+)"/;
